import { STRINGS } from '@tm/shared'

function filterToolboxByBlocks(toolbox, allowedSet) {
  if (!allowedSet || allowedSet.size === 0) return toolbox
  const filtered = []
  for (const category of toolbox.contents) {
    const contents = (category.contents || []).filter((item) => allowedSet.has(item.type))
    if (contents.length > 0) {
      filtered.push({ ...category, contents })
    }
  }
  return { ...toolbox, contents: filtered }
}

export function createToolboxForTemplate(availableBlocks) {
  if (!availableBlocks || availableBlocks.length === 0) return toolboxCategories
  return filterToolboxByBlocks(toolboxCategories, new Set(availableBlocks))
}

export const toolboxCategories = {
  kind: 'categoryToolbox',
  contents: [
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryEvents,
      colour: '#F5A623',
      contents: [
        { kind: 'block', type: 'event_when_start' },
        { kind: 'block', type: 'event_when_sprite_clicked' },
        { kind: 'block', type: 'event_when_collide' },
        { kind: 'block', type: 'event_when_key' },
        { kind: 'block', type: 'event_every_n_seconds' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryMotion,
      colour: '#4A90E2',
      contents: [
        { kind: 'block', type: 'motion_move_right' },
        { kind: 'block', type: 'motion_move_left' },
        { kind: 'block', type: 'motion_move_up' },
        { kind: 'block', type: 'motion_move_down' },
        { kind: 'block', type: 'motion_jump' },
        { kind: 'block', type: 'motion_goto' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryLooks,
      colour: '#9966CC',
      contents: [
        { kind: 'block', type: 'looks_show' },
        { kind: 'block', type: 'looks_hide' },
        { kind: 'block', type: 'looks_scale' },
        { kind: 'block', type: 'looks_say' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategorySound,
      colour: '#4CAF50',
      contents: [
        { kind: 'block', type: 'sound_play' },
        { kind: 'block', type: 'sound_loop' },
        { kind: 'block', type: 'sound_stop' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryLogic,
      colour: '#FF8C00',
      contents: [
        { kind: 'block', type: 'logic_if' },
        { kind: 'block', type: 'logic_if_else' },
        { kind: 'block', type: 'logic_compare_equal' },
        { kind: 'block', type: 'logic_compare_less' },
        { kind: 'block', type: 'logic_compare_greater' },
        { kind: 'block', type: 'logic_touching' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryLoop,
      colour: '#FF6F61',
      contents: [
        { kind: 'block', type: 'loop_repeat' },
        { kind: 'block', type: 'loop_forever' },
        { kind: 'block', type: 'loop_wait' },
        { kind: 'block', type: 'loop_wait_until' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryMath,
      colour: '#9C27B0',
      contents: [
        { kind: 'block', type: 'math_number' },
        { kind: 'block', type: 'math_random' },
        { kind: 'block', type: 'sprite_ref' },
      ],
    },
    {
      kind: 'category',
      name: STRINGS.toolboxCategoryEnd,
      colour: '#E74C3C',
      contents: [{ kind: 'block', type: 'end_stop_all' }],
    },
  ],
}
